export class BorrowerValueSections {

  usOwnerOverview = [
    'bankruptcy',
    'bankruptcy_status',
    'bankruptcy_discharged_date',
    'bankruptcy_chapter',
    'veteran_status',
    'annual_personal_income',
    'absenteeOwnership',
    'ownerBirthDate',
    'ownerPhoneCountryCodeId',
    'owner_phone',
    'owner_street_address',
    'owner_street_address_',
    'owner_city',
    'owner_state',
    'owner_zip',
  ];

  intlOwnerOverview = [
    'bankruptcy',
    'bankruptcy_status',
    'bankruptcy_discharged_date',
    'bankruptcy_chapter',
    'veteran_status',
    'annual_personal_income',
    'absenteeOwnership',
    'ownerBirthDate',
    'ownerPhoneCountryCodeId',
    'owner_phone',
    'owner_street_address',
    'owner_street_address_',
    'owner_street_address_three',
    'owner_city',
    'ownerZone',
    'owner_zip',
  ];

  businessOverview = [
    'doingBusinessAsName', // PPP Question
    'averageMonthlyPayroll', // PPP Question
    'number_of_employees', // PPP Question
    'industry_naics', // NAICS industry search, PPP Question?
    'annualRevenue',
    'average_monthly_sales',
    'annual_profits',
    'monthlyCharges',
    'nonprofit',
    'seasonal_business',
    'business_start_date',
    'business_location_type',
    'business_property_type_own_rent',
    'entity_type',
    'primaryCustomer',
    'acceptsCredit',
    'lendioIndustry',
    'companyOfficer',
    'useAccountingSoftware',
    'percentOwnership',
    'authorizedOwner',
    'amexMerchant',
    'amexMerchantNumber',
    'businessDebtAmount',
    'monthlyDebtPayments',
    'hasInvoices',
    'federalstate_tax_id',
    'beneficiaryOwners',
    'managingPartners',
    'interestedInPPPLoanForgiveness',
    'ucc_filing_date',
    'ucc_secured_party',
    'propertyOwnerName',
    'propertyOwnerPhoneCountryCodeId',
    'propertyOwnerPhone',
    'state_of_incorporation',
    'leasemortgage_payment',
    'equipment_description',
    'businessWebsite',
    'borrowerName',
  ];

  usBusinessContact = [
    'borrowerPhoneCountryCodeId',
    'borrowerPhone',
    'borrowerCanText',
    'marketingSmsOptIn',
    'borrowerStreet',
    'borrowerStreet2',
    'borrowerCity',
    'borrowerState',
    'borrowerZip',
    'borrowerZipExtra',
  ];

  intlBusinessContact = [
    'borrowerPhoneCountryCodeId',
    'borrowerPhone',
    'borrowerCanText',
    'marketingSmsOptIn',
    'borrowerStreet',
    'borrowerStreet2',
    'borrowerStreet3',
    'borrowerCity',
    'borrowerZone',
    'borrowerZip',
  ];

  financingPreferences = [
    'financeAmount',
    'loanPurpose',
    'accountsReceivableAmount',
    'assetsValue',
    'hasDownPayment',
    'maxWeeksToFunds',
    'collateralTypes',
    'fundAspect',
    'comments',
    'currentBorrowerInterest',
  ];

  borrowerCredit = [
    'creditScore',
    'personal_credit_score_verified',
    'derogCounter',
    'revolvingBalance',
    'inquiriesDuringLast6Months',
    'publicRecordsCount',
    'totalTradeItems',
    'delinquenciesOver30Days',
    'delinquenciesOver60Days',
    'delinquenciesOver90Days',
    'installmentBalance',
    'realEstateBalance',
    'revolvingBalance',
    'revolvingAvailablePercent',
  ];

  pppInfo = [
    'pppLabel',
    'pppReq1', // 'PPP Excluded' PPP Question
    'pppReq2', // 'DBA Defaulted' PPP Question
    'pppReq3', // 'Has Other Business' PPP Question
    'pppReq3Addendum', // PPP Question
    'pppReq4', // 'Needs Injury Assistance' PPP Question
    'pppReq4Addendum', // PPP Question
    'pppReq7', // PPP Question
    'pppReq8', // PPP Question
    'pppReq9', // PPP Question
    'businessType', // PPP Question
    'sbaFranchiseId', // PPP Question?
    'pppLoanPurpose', // PPP Question
    'pppOtherLoanPurpose', // PPP Question
    'pppLoanAmount', // PPP Question - Requested Loan Amount (used for Draw 1 *and* Draw 2)
    'ppp1LenderName', // PPP Draw 1 Lender
    'ppp1LoanAmount', // PPP Draw 1 Funded Loan Amount
    'ppp1SbaNumber', // PPP Draw 1 Funded SBA Number
    'eidlLoanNumber',
    'eidlRefinanceAmount',
    'scheduleCIncomeType', // Schedule C businesses will use this to show gross income or net profit
  ];

  //Credit Tab Finances
  creditTabFinances = [
    'annual_profits',
    'annualRevenue',
    'average_monthly_sales',
    'businessDebtAmount',
    'monthlyDebtPayments',
  ];

  // ERC Application Tab
  ercQualification = [
    'has_w2_employees',
    'impacted_by_govt_order',
    'revenue_decreased_2020_2021',
    'operation_start_date',
    'average_employees_2020',
    'average_employees_2020',
    'average_employees_2021',
  ];

  ercBasicInfo = [
    'uses_peo',
    'shutter_venue_operator_grant',
    'restaurant_revitalization_grant',
    'research_development_tax_credit',
    'indian_employment_credit',
    'fmla_extension_credit',
    'ffcra_paid_leave_tax_credits',
    'empowerment_zone_credit',
    'paid_sick_leave_credit',
    'work_opportunity_credit',
    'no_grants_or_credits',
    'received_ppp_loan',
    'payroll_tax_filing_type',
  ];

  oldErcOwnershipInfo = [
    'single_majority_owner',
    'owns_other_businesses',
    'controls_other_businesses',
    'employs_relatives',
    'employed_relatives_names',
  ];

  ercOwnershipInfo = [
    'contactsOwnOtherBusinesses',
    'hasRelatedOwners',
    'spouseOwnsOtherBusinesses',
    'hasRelatedW2Employees'
  ];

  ercBusinessInfo = [
    'borrowerStreet',
    'borrowerCity',
    'borrowerState',
    'borrowerZip',
    'separate_mailing_address',
    'borrowerMailingStreet',
    'borrowerMailingCity',
    'borrowerMailingState',
    'borrowerMailingZip',
    'industry_naics',
    'average_employees_2019',
  ];

  ercGrossReceipts = [
    'operation_start_date',
    'quarterlyRevenue2019Q1',
    'quarterlyRevenue2019Q2',
    'quarterlyRevenue2019Q3',
    'quarterlyRevenue2019Q4',
    'quarterlyRevenue2020Q1',
    'quarterlyRevenue2020Q2',
    'quarterlyRevenue2020Q3',
    'quarterlyRevenue2020Q4',
    'quarterlyRevenue2021Q1',
    'quarterlyRevenue2021Q2',
    'quarterlyRevenue2021Q3',
    'quarterlyRevenue2021Q4',
  ];

  ercGovernmentOrderInfo = [
    'how_revenue_is_generated',
    'business_operation_locations',
    'customer_locations',
    'completely_shut_down',
    'shut_down_start',
    'shut_down_end',
    'mods_on_reopen',
    'prevented_customer_access',
    'customer_visit_affected_period',
    'customer_visits_comparable_period',
    'customer_visits_explanation',
    'reduction_in_customers_served',
    'customers_served_affected_period',
    'customers_served_comparable_period',
    'customers_served_explanation',
    'reduction_in_contracts',
    'contracts_affected_period',
    'contracts_comparable_period_',
    'contracts_explanation',
    'projects_affected',
    'projects_affected_period',
    'projects_comparable_period',
    'projects_affected_explanation',
    'production_declined',
    'production_affected_period',
    'production_comparable_period',
    'production_explanation',
    'sales_reduced',
    'sales_reduced_affected_period',
    'sales_reduced_comparable_period',
    'sales_reduced_explanation',
    'reduced_hours',
    'operation_hours_affected_period',
    'operation_hours_comparable_period',
    'reduced_hours_explanation',
    'staggered_shifts',
    'staggered_shifts_description',
    'staggered_shifts_explanation',
    'workspace_modifications',
    'workspace_modifications_description',
    'capacity_limitation',
    'capacity_affected_period',
    'capacity_comparable_period',
    'capacity_limitation_explanation',
    'in-person_meetings_affected',
    'meetings_affected_description',
    'meeting_affected_explanation',
    'suppliers_shutdown',
    'supplier_details',
    'supplier_shutdown_timeframe',
  ];

  ercPeoInfo = [
    'uses_peo',
    'peo_name',
    'peoFirstName',
    'peoLastName',
    'peoPhone',
    'peoEmail',
  ];

  ercPppInfo = [
    'received_ppp_loan',
    'ppp_loans',
    'ppp1LoanForgivenessType',
    'ppp1PayrollAmountClaimed',
    'ppp1CoverageStartDate',
    'ppp1CoverageEndDate',
    'ppp2LoanForgivenessType',
    'ppp2PayrollAmountClaimed',
    'ppp2CoverageStartDate',
    'ppp2CoverageEndDate',
  ];

  ercGrantAndCreditInfo = [
    'shutter_venue_operator_grant',
    'shutter_grant_amount',
    'shutter_grant_coverage_start',
    'shutter_grant_coverage_end',
    'restaurant_revitalization_grant',
    'restaurant_grant_amount',
    'restaurant_grant_coverage_start',
    'restaurant_grant_coverage_end',
    'research_development_tax_credit',
    'research_credit_amount',
    'research_credit_coverage_start',
    'research_credit_coverage_end',
    'indian_employment_credit',
    'indian_credit_amount',
    'indian_credit_coverage_start',
    'indian_credit_coverage_end',
    'fmla_extension_credit',
    'fmla_credit_amount',
    'fmla_credit_coverage_start',
    'fmla_credit_coverage_end',
    'ffcra_paid_leave_tax_credits',
    'ffcra_credit_amount',
    'ffcra_credit_coverage_start',
    'ffcra_credit_coverage_end',
    'empowerment_zone_credit',
    'empowerment_credit_amount',
    'empowerment_credit_coverage_start',
    'empowerment_credit_coverage_end',
    'paid_sick_leave_credit',
    'paid_leave_credit_amount',
    'paid_leave_credit_coverage_start',
    'paid_leave_credit_coverage_end',
    'work_opportunity_credit',
    'work_opportunity_credit_amount',
    'work_opportunity_credit_coverage_start',
    'work_opportunity_credit_coverage_end',
    'no_grants_or_credits',
  ];

  constructor(private locale: string) {}

  borrowerValueSections(tab: string) {
    switch (tab) {
      case 'overview': {
        return {
          'Owner Overview': this.locale === 'en-US' ? this.usOwnerOverview : this.intlOwnerOverview,
          'Business Overview': this.businessOverview,
          'Business Details': this.businessOverview,
          'Business Contact': this.locale === 'en-US' ? this.usBusinessContact : this.intlBusinessContact,
          'Financing Preferences': this.financingPreferences,
          'Borrower Credit': this.borrowerCredit,
          'Finances': this.creditTabFinances
          // 'PPP Info': this.pppInfo // Leaving this here in case PPP returns. See SMART-936.
        };
      }
      case 'erc': {
        return {
          'Qualifications': this.ercQualification,
          'Basic Info': this.ercBasicInfo,
          'Old Ownership Info': this.oldErcOwnershipInfo,
          'Ownership Info': this.ercOwnershipInfo,
          'Business Info': this.ercBusinessInfo,
          'Gross Receipts': this.ercGrossReceipts,
          'Government Order Info': this.ercGovernmentOrderInfo,
          'PEO Info': this.ercPeoInfo,
          'PPP Info': this.ercPppInfo,
          'Grant & Credit Info': this.ercGrantAndCreditInfo,
        };
      }
    }
  }
}
